import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { FaChartArea} from 'react-icons/fa';
import { CgOrganisation } from 'react-icons/cg';
import { GoPeople  } from "react-icons/go";
import { FaPeopleGroup } from "react-icons/fa6";
import { MdDomainAdd, MdOutlineGroupAdd } from "react-icons/md";
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const SidebarItem = ({ to, icon, label, exact }) => {
  return (
    <Nav.Item>
      <NavLink
        to={to}
        end={exact}
        className={({ isActive }) =>
          `nav-link d-flex align-items-center ${isActive ? 'active' : ''}`
        }
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <div style={{ marginRight: '10px' }}>{icon}</div>
        <span>{label}</span>
      </NavLink>
    </Nav.Item>
  );
};

const Sidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // State for sidebar visibility

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen); // Toggle sidebar open/close state
  };

  return (
    <>
      {/* Sidebar content */}
      <Nav className="sidebar open">
        <div className="sidebar-sticky">
          <SidebarItem
            to="/dashboard"
            icon={<FaChartArea />}
            label="Dashboard"
            exact
          />
          <SidebarItem
            to="/dashboard/queue/create"
            icon={<MdOutlineGroupAdd />}
            label="Create Queue"
          />
          <SidebarItem
            to="/dashboard/queue/list"
            icon={<GoPeople />}
            label="My Queues"
          />
          
          <SidebarItem
            to="/dashboard/queue/monitor"
            icon={<FaPeopleGroup />}
            label="Queue Management"
          />
          <SidebarItem
            to="/dashboard/createorganization"
            icon={<MdDomainAdd />}
            label="Create Organization"
          />
          <SidebarItem
            to="/dashboard/organizations-list"
            label="My Organizations"
            icon={<CgOrganisation />}
          />
        </div>
      </Nav>
      {isSidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}
        {/* Bottom Navigation Bar for Mobile */}
      <div className="bottom-nav">
        <NavLink to="/dashboard" end className="nav-item">
          <FaChartArea />
          <span>Dashboard</span>
        </NavLink>
        <NavLink to="/dashboard/queue/create" className="nav-item">
          <MdOutlineGroupAdd />
          <span>Create Queue</span>
        </NavLink>
        <NavLink to="/dashboard/queue/list" className="nav-item">
          <GoPeople />
          <span>My Queues</span>
        </NavLink>
        <NavLink to="/dashboard/queue/monitor" className="nav-item">
          <FaPeopleGroup />
          <span>Queue Mgmt</span>
        </NavLink>
        <NavLink to="/dashboard/createorganization" className="nav-item">
          <MdDomainAdd />
          <span>Create Org</span>
        </NavLink>
        <NavLink to="/dashboard/organizations-list" className="nav-item">
          <CgOrganisation />
          <span>My Orgs</span>
        </NavLink>
      </div>
    </>
  );
};

export default Sidebar;

